import React from 'react'
import Section from '../Section'
import NumberSearch from 'features/Numbers/NumberSearch'
import Markdown from 'features/Markdown'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'

export default props => (
  <Section
    color={props.color}
    paddingTop={props.paddingTop}
    sectionWidth="md"
    paddingBottom={props.paddingBottom}
  >
    <Markdown text={props.text} color={props.color} style={{ textAlign: 'center' }} />
    <div className={cn(sLay['layout-row'], sLay['layout-align-center-center'])}>
      <NumberSearch tabs={props.tabs || []} style={{ width: '100%', maxWidth: '500px' }} />
    </div>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/NumberSearch/NumberSearch.jsx